import styled from 'styled-components'
import Tooltip from 'components/Tooltip'
interface TabProps {
  isText?: boolean
}

interface ButtonProps {
  selected?: boolean
  isText?: boolean
}

export const FunctionBar = styled.div<TabProps>``

export const CusttomAnnotationButton = styled.button<ButtonProps>`
  margin-top: 10px;
  width: 3rem;
  background: none;
  color: ${(props) => (props.isText ? '' : '#4A4A4A')};
  border: none;

  &[data-openModal='true'] {
    color: #fff;
  }

  &[data-fullSreen='true'] {
    color: #fff;
  }
`

export const ToolsMenuTooltip = styled(Tooltip)`
  span {
    position: absolute;

    top: initial;
    right: 10px;

    left: 1.5rem;

    background: ${({ theme }) => `rgb(${theme.component.accent})`};
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    font-size: 12px;

    &::before {
      all: unset;

      content: '';

      position: absolute;
      bottom: -30%;
      right: 50%;

      transform: translateY(-50%) rotateZ(45deg);

      background: ${({ theme }) => `rgb(${theme.component.accent})`};

      width: 8px;
      height: 8px;
    }
  }
`
